import { SchedulerEnglishTranslation } from './scheduler'

export const EnglishTranslations = {
	...SchedulerEnglishTranslation,
}
